export const CONTENT = {
    ALL: 0,
    INFORMATIVE: 1,
    STATISTIC: 2,
    EXPORTS: 3,
    CONSULTING: 4,
    CONSULTING_SAFRAS_TV: 5,
    CONSULTING_SAFRAS_PODCAST: 6,
    CONSULTING_COURSES: 7,
    CONSULTING_SPEECHES: 8,
    CONSULTING_EXCHANGE: 9,
    NEWS: 10,
    ASK_ANALYST: 11,
    WEATHER: 12,
    PHYSICAL_MARKET: 13,
    FUTURE_MARKET: 14,
    INDICATIVE_MARKET: 15,
    EXCHANGE_MARKET: 16,
    ACTIVE_MARKET: 17,
    HEDGE_WHATS: 18,
    HEDGE_COMMODITIES: 19,
    HEDGE_CAMBIAL: 20,
    WHAT_IS_IT: 21,
    CALENDAR: 24,
};